import React from 'react';

export default function ReportsPage() {
  return <div style={{ padding: '20px 24px' }}>
    <h1>Reports</h1>
    <p>Platform reporting and diagnostics will appear here as they become available.</p>
    <section aria-label="Reporting availability">
      <h2>Coming later</h2>
      <p>Platform activity and diagnostics, print activity, and transaction activity reports are not yet available here.</p>
    </section>
    <p>Application-specific reports belong within their owning applications.</p>
  </div>;
}
